module.exports = __webpack_public_path__ + "static/media/ic_line_selected.b768f054.svg";